import { AVAILABILITY_BT_CONSTS } from '../consts';

/**
 * @param {import('../composables').AvailabilityBigTicketParserData} availabilityInfo
 */

export const availabilityBigTicketParser = (availabilityInfo) => {
  const { availabilityData, zipCode, lookupIds } = availabilityInfo;
  /** @type {string}  */
  const objectKey = `${zipCode}_${lookupIds}`;
  const currentZipCodeAvailabilityData = availabilityData[objectKey];

  /** @type {{ [key: number]: import('../composables').BigTicketAvailability }} */
  const parsedAvailability = {};

  /**
 * @param {{
  *   deliverability: {
  *     deliverabilityMessage: string,
  *     status: string,
  *   }
  * }} upc
  */
  const getUpcStatus = (upc) => {
    const { status, deliverabilityMessage } = (upc && upc.deliverability) || {};
    const availableStatus = deliverabilityMessage && AVAILABILITY_BT_CONSTS.AVAILABLE_CODES.indexOf(status) !== -1;
    const onOrderStatus = deliverabilityMessage && AVAILABILITY_BT_CONSTS.ON_ORDER_CODES.indexOf(status) !== -1;
    const isAvailableStatusOnOrder = onOrderStatus ? AVAILABILITY_BT_CONSTS.ON_ORDER : '';
    const available = availableStatus ? AVAILABILITY_BT_CONSTS.AVAILABLE : isAvailableStatusOnOrder;
    return {
      available,
      showUnavailableMessage: !available && AVAILABILITY_BT_CONSTS.UNAVAILABLE_MESSAGES.indexOf(deliverabilityMessage) !== -1,
    };
  };

  /**
   * @param { import('../composables').BigTicketAvailabilityProductData } productData
   */

  const setAvailabilityUpcsObject = (productData) => {
    const { upcs = [] } = productData;
    upcs.forEach((upcData) => {
      const { available, showUnavailableMessage } = getUpcStatus(upcData);
      upcData.bigTicketAvailable = available;
      upcData.showUnavailableMessage = showUnavailableMessage;
      parsedAvailability[upcData.upcId] = upcData;
    });
  };

  /**
   * @param { import('../composables').BigTicketAvailabilityProductDataDefault } data
  */

  const buildUpcsWithAvailability = (data) => {
    if (Array.isArray(data)) {
      data.forEach((productData) => setAvailabilityUpcsObject(productData));
    }
  };

  const productArray = currentZipCodeAvailabilityData?.products?.product;

  buildUpcsWithAvailability(productArray);

  return parsedAvailability;
};
export default availabilityBigTicketParser;
